const turnstileScript =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=onloadTurnstileCallback';

export const turnstileKey = process.env.MIX_TURNSTILE_KEY;
export let turnstileLoaded = false;

let resolveTurnstileLoading = (status) => {};

export const turnstileLoading = new Promise((resolve) => {
  resolveTurnstileLoading = resolve;
});

export const initTurnstile = async () => {
  turnstileLoaded = true;

  await loadScript(turnstileScript);
  window.onloadTurnstileCallback = () => {
    resolveTurnstileLoading(true);
  };
};

export const renderTurnstile = (setTokenCallback = null, dark = false) => {
  if(!turnstileLoaded){
    initTurnstile();
  }
  return turnstileLoading.then(() => {
    // render captcha
    return new Promise((resolve) => {
      const widgetId = window.turnstile.render('#cf-turnstile', {
        sitekey: turnstileKey,
        'response-field-name': 'captcha_token',
        action: 'register',
        theme: dark ? 'dark' : 'light',
        callback: (token) => {
          if(typeof setTokenCallback === 'function'){
            setTokenCallback(token);
          }
          resolve({ widgetId, token });
        },
      });
    });
  });
};
export const loadScript = (fileUrl, async = true, type = 'text/javascript') => {
  return new Promise((resolve, reject) => {
    try {
      const scriptElement = document.createElement('script');
      scriptElement.type = type;
      scriptElement.async = async;
      scriptElement.src = fileUrl;

      scriptElement.addEventListener('load', () => {
        resolve({ status: true });
      });

      scriptElement.addEventListener('error', () => {
        reject({
          status: false,
          message: `Failed to load the script ＄{fileUrl}`,
        });
      });

      document.body.appendChild(scriptElement);
    } catch (error) {
      reject(error);
    }
  });
};
